import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import EmailWidget from '../components/dashboard/EmailWidget';
import CalendarWidget from '../components/dashboard/CalendarWidget';
import RecentNotesWidget from '../components/dashboard/RecentNotesWidget';
import BookTrackerWidget from '../components/dashboard/BookTrackerWidget';
import { useAuthStore } from '../store/auth';
import { PageLayout } from '../layout/primitives';

const DashboardPage: React.FC = () => {
  const user = useAuthStore((s) => s.user);
  const fetchUser = useAuthStore((s) => s.fetchUser);

  useEffect(() => {
    if (!user) fetchUser();
  }, [user, fetchUser]);

  const greeting = React.useMemo(() => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 17) return 'Good afternoon';
    return 'Good evening';
  }, []);

  return (
    <PageLayout contentMaxWidth={1600} paddingMode="shell">
      <Typography
        variant="h4"
        sx={{
          mb: { xs: 2, md: 3 },
          fontSize: { xs: '1.75rem', sm: '2rem', md: '2.125rem' },
        }}
      >
        {greeting}{user ? `, ${user.name.split(' ')[0]}` : ''}
      </Typography>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: 'minmax(0, 1fr)',
            md: 'minmax(0, 5fr) minmax(0, 7fr)',
          },
           gridTemplateAreas: {
             xs: `
               "notes"
               "email"
               "calendar"
               "books"
             `,
             md: `
               "calendar email"
               "notes books"
             `,
           },
          gap: { xs: 2, md: 3 },
          alignItems: 'stretch',
        }}
      >
        <Box
          sx={{
            gridArea: 'notes',
            minWidth: 0,
          }}
        >
          <RecentNotesWidget />
        </Box>
        <Box
          sx={{
            gridArea: 'calendar',
            minWidth: 0,
          }}
        >
          <CalendarWidget />
        </Box>
        <Box
          sx={{
            gridArea: 'email',
            minWidth: 0,
          }}
        >
          <EmailWidget />
        </Box>
        <Box
          sx={{
            gridArea: 'books',
            minWidth: 0,
          }}
        >
          <BookTrackerWidget />
        </Box>
      </Box>
    </PageLayout>
  );
};

export default DashboardPage;
